import { ReactElement, useEffect, useState } from "react";
import { useRouter } from "next/router";

import { AuthUserRole } from "@ascendnow/shared";

import AscLogoAdmin from "../AscLogoAdmin/AscLogoAdmin";
import AscTopNavAdmin from "../AscTopNavAdmin/AscTopNavAdmin";
import AscAdminSidebar from "../AscAdminSidebar/AscAdminSidebar";
import styles from "./AscAdminLayout.module.scss";

interface SidebarItemProp {
  id: string;
  icon: any;
  path: string;
  text: string;
  title?: string;
  subTitle?: string;
  disabled?: boolean;
  parent?: string;
  isParent?: boolean;
}

export interface AscAdminLayoutProps {
  children?: any;
  notificationsCount: number;
  userImage?: ReactElement;
  name: string;
  schoolName?: string;
  customNavigateFunction?: (path: string) => void;
  onClickProfile?: () => void;
  onClickHelp?: () => void;
  onClickLogOut?: () => void;
  hideSidebarAndTopNav?: boolean;
  sidebarItems: SidebarItemProp[];
  role?: AuthUserRole;
  schoolStuffCredits?: number;
  teacherStuffCredits?: number;
}

export default function AscAdminLayout({
  children,
  notificationsCount,
  userImage,
  name,
  schoolName,
  onClickLogOut,
  onClickProfile,
  onClickHelp,
  hideSidebarAndTopNav = false,
  sidebarItems,
  role,
  schoolStuffCredits,
  teacherStuffCredits,
}: AscAdminLayoutProps) {
  const router = useRouter();
  const [activePage, setActivePage] = useState<any>(null);

  useEffect(() => {
    const activeSidebarMenu = sidebarItems.find(
      (item) => item.path === router.pathname
    );

    if (activeSidebarMenu && typeof activeSidebarMenu === "object") {
      setActivePage(activeSidebarMenu);
    }

    //eslint-disable-next-line
  }, [router.pathname, sidebarItems]);

  if (hideSidebarAndTopNav) {
    return children;
  }

  return (
    <div className={styles.container}>
      <AscAdminSidebar
        className={styles.sidebar}
        header={<AscLogoAdmin className={styles.logo} />}
        headerClassName={styles.header}
        collapsedHeader={<AscLogoAdmin condensed />}
        width="15.25rem"
        collapsedWidth="4.75rem"
        selectedId={activePage?.id}
        customNavigateFunction={(path) => router.push(path)}
      >
        {sidebarItems.map((item: SidebarItemProp) => (
          <AscAdminSidebar.Item
            key={item.id}
            id={item.id}
            icon={<item.icon />}
            path={item.path}
            parent={item.parent}
            isParent={item.isParent}
          >
            {item.text}
          </AscAdminSidebar.Item>
        ))}
      </AscAdminSidebar>

      <div className={styles.devider}>
        <AscTopNavAdmin
          className={styles.topNav}
          pageName={activePage?.text}
          title={activePage?.title}
          schoolStuffCredits={schoolStuffCredits}
          teacherStuffCredits={teacherStuffCredits}
          subTitle={activePage?.subTitle}
          notificationsCount={notificationsCount}
          avatarUrl={userImage}
          name={name}
          schoolName={schoolName}
          onClickProfile={onClickProfile}
          onClickHelp={onClickHelp}
          onClickLogOut={onClickLogOut}
          role={role}
        />
        <div className={styles.children}>{children}</div>
      </div>
    </div>
  );
}
